import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import Select from 'react-select';
import { CustomStyle } from '../../../../../components/CustomSelectStyle';
import { CustomStyle as CustomStyleDarkTheme } from '../../../../../components/CustomSelectStyleDarkTheme';
import FilterRadioButton from '../../../../../components/FilterRadioButtons';
import FormGroup from '../../../../../components/FormGroup';
import MyModal from '../../../../../components/Modal';
import useThemeContext from '../../../../../contexts/theme';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
import { OptionType, PeriodType } from '../../types';
import { MonthsGrid } from './styles';

interface ISearchByFileModal {
  searchByFileModalShow: boolean;
  setSearchByFileModalShow: Dispatch<SetStateAction<boolean>>;
  searchByFile: (file: OptionType) => Promise<void>;
  fileOptions: OptionType[];
  loadListsForSearching: (month?: number, year?: number) => Promise<void>;
}

export default function SearchByFileModal({
  searchByFileModalShow,
  setSearchByFileModalShow,
  searchByFile,
  fileOptions,
  loadListsForSearching,
}: ISearchByFileModal) {
  const [selectedFile, setSelectedFile] = useState({} as OptionType);
  const [periodBeingSelected, setPeriodBeingSelected] = useState({
    month: (new Date()).getMonth() + 1,
    year: (new Date()).getFullYear(),
  } as PeriodType);

  const { selectedTheme } = useThemeContext();

  const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const monthsMap: { [key: number]: string } = {
    1: 'Janeiro',
    2: 'Fevereiro',
    3: 'Março',
    4: 'Abril',
    5: 'Maio',
    6: 'Junho',
    7: 'Julho',
    8: 'Agosto',
    9: 'Setembro',
    10: 'Outubro',
    11: 'Novembro',
    12: 'Dezembro',
  };

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  const { companyCode } = useGetGeneralAppData();

  function handleSelectedFileChange(wp: OptionType) {
    setSelectedFile(wp);
  }

  useEffect(() => {
    if (companyCode) {
      loadListsForSearching(periodBeingSelected.month, periodBeingSelected.year);
      setSelectedFile({} as OptionType);
    }
  }, [periodBeingSelected, loadListsForSearching, companyCode]);

  return (
    <MyModal
      show={searchByFileModalShow}
      title={'Pesquisar por Arquivo'}
      closeButtonLabel="Fechar"
      actionButtonLabel={'Pesquisar'}
      onClose={() => setSearchByFileModalShow(false)}
      onAction={() => searchByFile(selectedFile)}
      type="action"
      size='lg'
      modalBody={(
        <div className="modal-body-centered">
          <div className="year-selection">
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  year: Number(currentYear) - 2
                }));
              }}
              selected={periodBeingSelected.year == Number(currentYear) - 2}
            >
              {String(Number(currentYear) - 2)}
            </FilterRadioButton>
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  year: Number(currentYear) - 1
                }));
              }}
              selected={periodBeingSelected.year == Number(currentYear) - 1}
            >
              {String(Number(currentYear) - 1)}
            </FilterRadioButton>
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  year: Number(currentYear)
                }));
              }}
              selected={periodBeingSelected.year == Number(currentYear)}
            >
              {currentYear}
            </FilterRadioButton>
          </div>
          <MonthsGrid>
            {months.map((month) => (
              <FilterRadioButton
                key={month}
                onClick={() => setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  month,
                }))}
                selected={month == periodBeingSelected.month}
                invisible={currentYear === periodBeingSelected.year && month > currentMonth}
              >
                {monthsMap[month]}
              </FilterRadioButton>
            ))}
          </MonthsGrid>
          <FormGroup>
            <label htmlFor="contactName">Selecione o arquivo</label>
            <Select
              value={selectedFile}
              options={fileOptions}
              onChange={(fl) => handleSelectedFileChange(fl as OptionType)}
              placeholder="Selecionar Arquivo"
              styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
              classNamePrefix="react-select"
              className="react-select-container"
            />
          </FormGroup>
        </div>
      )}
      minHeight='500px'
      isActionButtonDisabled={!selectedFile.value}
    />
  );
}
